module.exports = __webpack_public_path__ + "img/8.a0c0c1ba.jpg";